import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { LINKS } from '../../../../../Routs/config';
import { Loader } from '../../../../../generic/ui/Loader';
import { ScrollArea, Surface } from '../../../../../generic/ui/Surface';
import DriversModals from '../Components/DriversModals';
import DriversPageLayout from '../Components/DriversPageLayout';
import DriversSelectBar from '../Components/DriversSelectBar';
import KavCard from '../Components/KavCard';
import { useDrivers } from '../services/DriversContext';

const KavListPage: React.FC = () => {
    const navigate = useNavigate();
    const {
        data,
        renderList,
        isLoading,
        input,
        setInput,
        setDate,
        handleDate,
        defaultDate,
        isOffice,
        handleActionMovments,
        printLogPdf,
        getPackageStatisticByKav,
    } = useDrivers();

    const isEmpty = !isLoading && data !== null && renderList.length === 0;

    return (
        <DriversPageLayout title='נסיעות שלי'>
            <DriversModals />

            <DriversSelectBar
                input={input}
                setInput={setInput}
                setDate={setDate}
                handleDate={handleDate}
                selectedDate={defaultDate ? new Date(defaultDate) : false}
                isOffice={isOffice}
                onPrintLog={() => printLogPdf()}
            />

            <Surface>
                <ScrollArea>
                    {isLoading ? (
                        <CenterState>
                            <Loader size={56} />
                        </CenterState>
                    ) : isEmpty ? (
                        <EmptyState>
                            <img src='/images/no-data.png' alt='empty data' />
                        </EmptyState>
                    ) : (
                        renderList.map((item, idx) => (
                            <KavCard
                                key={item.AreaID}
                                item={item}
                                isOffice={isOffice}
                                variant='list'
                                isLast={idx === renderList.length - 1}
                                onOpen={(areaID) =>
                                    navigate(`${LINKS.drivers.quests.kavURL}${areaID}`)
                                }
                                onAction={handleActionMovments}
                                onPrintLog={printLogPdf}
                                onOpenStatistic={getPackageStatisticByKav}
                            />
                        ))
                    )}
                </ScrollArea>
            </Surface>
        </DriversPageLayout>
    );
};

export default KavListPage;

const CenterState = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;
`;

const EmptyState = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;

    img {
        max-width: 30%;
        opacity: 0.9;
    }
`;
